<template>
  <tp-vote/>
</template>

<script>
import store from "../store/store";

let tpId = store.state.themes.templateID;
let tpVote = () => import("@/components/template/model" + tpId + "/vote.vue");
export default {
  name: "vote",
  components: {
    tpVote,
  },
  beforeRouteLeave(to, from, next) {
    this.$route.meta.savedPosition = {
      x: 0,
      y: document.documentElement.scrollTop,
    };
    console.log("离开高度", document.documentElement.scrollTop);
    next();
  },
};
</script>
